import { useEffect, useRef, useState } from 'react'
// import { IGetGroundingDetailsResponse } from 'types/groundingTypes'
import { StyledSignatureBox } from './SignatureBox.styled'
import SignatureCanvas from 'react-signature-canvas'
import { GroundingReturn } from '../../types/Grounding/GroundingResult'
import { GENERAL_ERROR_MESSAGE } from 'common/constants'
import { DispositionOption } from 'types/Grounding/groundingTypes'
// import { ERROR_LESSEE_SIGNATURE_REQUIRED_MESSAGE, ERROR_RETAILER_SIGNATURE_REQUIRED_MESSAGE } from 'common/constants'
// import { SignatureTypes } from 'types/groundingTypes'

interface ISignatureBoxProps {
  title: string
  canvasHeight: number
  index: number
  configText?: string
  groundingData: GroundingReturn
  image?: string
  setGroundingData?: (data: GroundingReturn) => void
  isSubmit: boolean
  isDisabled?: boolean
  signatureTypeId: number
}

export const SignatureBox = ({
  title,
  canvasHeight,
  index,
  configText,
  groundingData,
  image,
  setGroundingData,
  isSubmit,
  isDisabled,
  signatureTypeId
}: ISignatureBoxProps) => {
  let signatureTypes = [...groundingData?.signatureTypes]
  let signPad = useRef(null)
  const [isSign, setIsSign] = useState(false)

  const clear = () => {
    signPad.current.clear()
    setIsSign(false)
    updateSign('')
  }

  const updateSign = (url: string) => {
    signatureTypes[index].signatureImage = url
    let newData = { ...groundingData, signatureTypes: signatureTypes }
    setGroundingData(newData)
  }

  const drawLineToCanvas = (canvas: HTMLCanvasElement) => {
    let canvasContext = canvas.getContext('2d')
    canvasContext.clearRect(0, 0, canvas.width, canvas.height)
    canvasContext.fillStyle = 'white'
    canvasContext.fillRect(0, 0, canvas.width, canvas.height)
    canvasContext.beginPath()
    canvasContext.lineWidth = 2
    canvasContext.strokeStyle = '#ccc'
    canvasContext.moveTo(5, 85)
    canvasContext.lineTo(canvas.width - 5, 85)
    canvasContext.stroke()
    canvasContext.closePath()

    canvasContext.lineWidth = 2
    canvasContext.strokeStyle = '#145394'
  }

  const drawLineToCanvasByIndex = (index: number | null = null) => {
    const signCanvases = document.querySelectorAll('.signature-canvas')
    if (index !== null) {
      const canvas = signCanvases && (signCanvases[index] as HTMLCanvasElement)
      if (canvas) {
        drawLineToCanvas(canvas)
      }
    } else {
      signCanvases?.forEach((canvas: HTMLCanvasElement, i: number) => {
        drawLineToCanvas(canvas)
      })
    }
  }

  const init = () => {
    const canvas = document.getElementById(`signature-${title.toLowerCase()}`)
    canvas.addEventListener(
      'mouseleave',
      function (e: MouseEvent) {
        if (!signPad.current.isEmpty()) {
          setIsSign(true)
          updateSign(signPad.current.toDataURL())
        }
      },
      false
    )
    canvas.addEventListener(
      'touchend',
      function (e: MouseEvent) {
        if (!signPad.current.isEmpty()) {
          setIsSign(true)
          updateSign(signPad.current.toDataURL())
        }
      },
      false
    )
  }

  useEffect(() => {
    drawLineToCanvasByIndex()
    init()
    // updateSign('')
    if (image !== '') {
      signPad.current.fromDataURL(image)
      setIsSign(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (signPad.current) {
      if (isDisabled) {
        signPad.current.off()
      }
    }
  }, [isDisabled])

  return (
    <StyledSignatureBox id="signature-box">
      <div className="tool-bar">
        <div className="title">{title}</div>
        {!isDisabled && (
          <span
            className="clear-button"
            onClick={() => {
              clear()
              drawLineToCanvasByIndex(index)
            }}
          >
            Clear Signature
          </span>
        )}
      </div>
      <div>
        <div className="canvas-wrapper">
          {groundingData?.groundingDispositionSelected.ID !== DispositionOption.LESSEE_PURCHASE &&
            groundingData?.groundingDispositionSelected.ID !==
              DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT && (
              <div style={{ minHeight: '130px' }}>
                <span style={{ fontSize: '12px', lineHeight: '26px' }}>{configText}</span>
              </div>
            )}
          <div className="signature-content">
            <SignatureCanvas
              penColor="#145394"
              fromDataURL={image}
              canvasProps={{
                height: canvasHeight,
                id: `signature-${title.toLowerCase()}`,
                className: 'signature-canvas' + (isDisabled ? ' disabled' : '')
              }}
              clearOnResize={false}
              ref={signPad}
            />
          </div>
        </div>
      </div>

      <p className="error-label">{isSubmit && !isSign && GENERAL_ERROR_MESSAGE}</p>
    </StyledSignatureBox>
  )
}
